/**
 * Fleet CC DCRP Recovery API
 * Connected Claims Damaged Container Recovery APIs used for handling recovery data.
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../../services/encoder';

import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { ConsigneeModel } from '../models/consigneeModel';
import { CustomerModel } from '../models/customerModel';
import { RecoveryCaseType } from '../models/recoveryCaseType';
import { CancellationReasonsDto } from '../models/cancellationReasonsDto';
import { commodityModel } from '../models/commodityModel';
import { parentCommodityModel } from '../models/parentCommodityModel';

@Injectable()
export class MasterDataService {
  protected basePath = environment.ccdcrp_api_base_url;
  public defaultHeaders = new HttpHeaders();

  constructor(protected httpClient: HttpClient) {}

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets Consignees on the basis Customer Code
   *
   * @param customerCodes Customer Code
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public masterDataGetConsigneesGet(
    customerCodes?: string,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<ConsigneeModel>>;
  public masterDataGetConsigneesGet(
    customerCodes?: string,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<ConsigneeModel>>>;
  public masterDataGetConsigneesGet(
    customerCodes?: string,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<ConsigneeModel>>>;
  public masterDataGetConsigneesGet(
    customerCodes?: string,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (customerCodes !== undefined && customerCodes !== null) {
      queryParameters = queryParameters.set(
        'customerCodes',
        <any>customerCodes
      );
    }

    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    return this.httpClient.request<Array<ConsigneeModel>>(
      'get',
      `${this.basePath}/master-data/get-consignees`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Retrieves the cancellation reason for closing a recovery case based on its type
   *
   * @param recoveryCaseType Recovery case type
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public masterDataGetCancellationReason(
    recoveryCaseType?: RecoveryCaseType,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<CancellationReasonsDto>>;
  public masterDataGetCancellationReason(
    recoveryCaseType?: RecoveryCaseType,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<CancellationReasonsDto>>>;
  public masterDataGetCancellationReason(
    recoveryCaseType?: RecoveryCaseType,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<CancellationReasonsDto>>>;
  public masterDataGetCancellationReason(
    recoveryCaseType?: RecoveryCaseType,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams();
    if (recoveryCaseType) {
      queryParameters = queryParameters.set(
        'recoveryCaseType',
        <any>recoveryCaseType
      );
    }

    let headers = this.defaultHeaders;
    if (aPIVersion) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts.join(', '));
    return this.httpClient.request<Array<CancellationReasonsDto>>(
      'get',
      `${this.basePath}/master-data/cancellation-reasons`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
  /**
   * Gets Customers on the basis first three characters of Customer Code
   *
   * @param startsWith Customer Code Prefixing Initial Characters
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public masterDataGetCustomersCodeWithPrefixGet(
    startsWith?: string,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<CustomerModel>>;
  public masterDataGetCustomersCodeWithPrefixGet(
    startsWith?: string,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<CustomerModel>>>;
  public masterDataGetCustomersCodeWithPrefixGet(
    startsWith?: string,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<CustomerModel>>>;
  public masterDataGetCustomersCodeWithPrefixGet(
    startsWith?: string,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (startsWith !== undefined && startsWith !== null) {
      queryParameters = queryParameters.set('startsWith', <any>startsWith);
    }

    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    return this.httpClient.request<Array<CustomerModel>>(
      'get',
      `${this.basePath}/master-data/get-customers-code-with-prefix`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Gets Customers on the basis first three characters of Customer Name
   *
   * @param startsWith Customer Name Prefixing Initial Characters
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public masterDataGetCustomersNameWithPrefixGet(
    startsWith?: string,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<CustomerModel>>;
  public masterDataGetCustomersNameWithPrefixGet(
    startsWith?: string,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<CustomerModel>>>;
  public masterDataGetCustomersNameWithPrefixGet(
    startsWith?: string,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<CustomerModel>>>;
  public masterDataGetCustomersNameWithPrefixGet(
    startsWith?: string,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (startsWith !== undefined && startsWith !== null) {
      queryParameters = queryParameters.set('startsWith', <any>startsWith);
    }

    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    return this.httpClient.request<Array<CustomerModel>>(
      'get',
      `${this.basePath}/master-data/get-customers-name-with-prefix`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Gets Consignees on the basis of first three characters of Consignee Name
   *
   * @param startsWith Consignee Name Prefixing Initial Characters
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public masterDataGetConsigneeNameWithPrefixGet(
    startsWith?: string,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<ConsigneeModel>>;
  public masterDataGetConsigneeNameWithPrefixGet(
    startsWith?: string,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<ConsigneeModel>>>;
  public masterDataGetConsigneeNameWithPrefixGet(
    startsWith?: string,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<ConsigneeModel>>>;
  public masterDataGetConsigneeNameWithPrefixGet(
    startsWith?: string,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });

    if (startsWith !== undefined && startsWith !== null) {
      queryParameters = queryParameters.set('startsWith', <any>startsWith);
    }

    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    return this.httpClient.request<Array<ConsigneeModel>>(
      'get',
      `${this.basePath}/master-data/get-consignee-name-with-prefix`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Gets Consignees on the basis first three characters of Consignee Code
   *
   * @param startsWith Consignee Code Prefixing Initial Characters
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public masterDataGetConsigneeCodeWithPrefixGet(
    startsWith?: string,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<ConsigneeModel>>;
  public masterDataGetConsigneeCodeWithPrefixGet(
    startsWith?: string,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<ConsigneeModel>>>;
  public masterDataGetConsigneeCodeWithPrefixGet(
    startsWith?: string,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<ConsigneeModel>>>;
  public masterDataGetConsigneeCodeWithPrefixGet(
    startsWith?: string,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });

    if (startsWith !== undefined && startsWith !== null) {
      queryParameters = queryParameters.set('startsWith', <any>startsWith);
    }

    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    return this.httpClient.request<Array<ConsigneeModel>>(
      'get',
      `${this.basePath}/master-data/get-consignee-code-with-prefix`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Get list of Parent Commodities.
   *
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public masterDataGetParentCommoditiesGet(
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<parentCommodityModel>>;
  public masterDataGetParentCommoditiesGet(
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<parentCommodityModel>>>;
  public masterDataGetParentCommoditiesGet(
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<parentCommodityModel>>>;
  public masterDataGetParentCommoditiesGet(
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });

    let headers = this.defaultHeaders;

    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    return this.httpClient.request<Array<parentCommodityModel>>(
      'get',
      `${this.basePath}/master-data/get-parent-commodities`,
      {
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Get list of Commodities.
   *
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public masterDataGetCommoditiesGet(
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<commodityModel>>;
  public masterDataGetCommoditiesGet(
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<commodityModel>>>;
  public masterDataGetCommoditiesGet(
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<commodityModel>>>;
  public masterDataGetCommoditiesGet(
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    return this.httpClient.request<Array<commodityModel>>(
      'get',
      `${this.basePath}/master-data/get-commodities`,
      {
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
